import { Folder, FoldersInvariants } from 'src/models/resumeFolders';

export const MAX_FOLDERS_WITHOUT_SCROLL = 49;

export const MAX_RESUMES_WITHOUT_LINKSWITCH = 5;

export const getFolderById = ({ own, shared, trash }: FoldersInvariants, folderId: number): Folder | undefined =>
    own?.[folderId] || shared?.[folderId] || trash?.[folderId];

export const getFolderUrl = (folderId: number): string => `/employer/resumefolders/folder?folder=${folderId}`;

export const RESUME_FOLDERS_URL = '/employer/resumefolders';
